import script from "./InputElement.vue?vue&type=script&setup=true&lang=js"
export * from "./InputElement.vue?vue&type=script&setup=true&lang=js"

import "./InputElement.vue?vue&type=style&index=0&id=406d1a5b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-406d1a5b"]])

export default __exports__